import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { filesActionCreators } from '..';
import * as api from '../filesApi';

function* fetchFilesSaga(action: ReturnType<typeof filesActionCreators.fetchFiles>) {
  const key = `${action.payload.container}_${action.payload.folder}`;
  yield put(filesActionCreators.toggleLoading(key));
  try {
    const response = yield* call(api.fetchFiles, action.payload);

    yield put(filesActionCreators.setFiles(response, action.payload));
    //yield put(filesActionCreators.setSalesDocuments(response));
  } catch {
    //
  }

  yield put(filesActionCreators.toggleLoading(key));
}

export function* watchFetchFiles() {
  yield takeEvery(filesActionCreators.fetchFiles.match, fetchFilesSaga);
}
